import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import Picture from '@/image/hotel/hotel_top.jpg';
import { VerticalTextImage } from '@/components/common/VerticalTextImage'; // 共通コンポーネントのインポート
import { AboutContent } from '@/components/hotel/AboutContent';
import { Location } from '@/components/hotel/Location';
import { MagazineParts } from '@/components/hotel/MagazineParts';
import { MenuBar } from '@/components/common/MenuBar';
import { News } from '@/components/hotel/News';
import { FooterItems } from '@/components/common/FooterItems';
import { MonthlyPlan } from '@/components/hotel/MonthlyPlan';

export const HotelPage = () => {
  const location = useLocation();
  const langSegment = location.pathname.split('/')[1];
  const useEnglish = langSegment === 'en';

  // Meta / OGP の内容を言語判定に応じて設定
  const metaTitle = useEnglish
    ? 'The Apartment Hotel by stylio（Official）｜Tokyo Local Stay'
    : 'The Apartment Hotel by stylio（公式）｜東京のネイバーフッドを感じるアパートメントホテル';
  const metaDescription = useEnglish
    ? "We propose a hotel stay woven into Tokyo's neigborhoods.\nThe apartment hotel brand combines easy accessiblity from central Tokyo, while offering a local stay in the cool neighboorhoods."
    : 'ネイバーフッドが豊かな旅を。\n都心へのアクセス性と魅力的な生活圏を兼ねそろえるアパートメントホテル。';
  const ogpTitle = useEnglish
    ? 'The Apartment Hotel by stylio（Official）｜Tokyo Local Stay'
    : 'The Apartment Hotel by stylio｜東京のネイバーフッドを感じるアパートメントホテル';
  const ogpDescription = metaDescription;
  // 画像がないため、OGP Image は未設定とします

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:title" content={ogpTitle} />
        <meta property="og:description" content={ogpDescription} />
        <meta property="og:url" content={window.location.href} />
      </Helmet>
      <MenuBar
        leftText="Monthly Plan"
        rightText="Book Room"
        leftLink="/monthly"
        rightLink="/hotel/properties"
      >
        <div className="bg-whiteYellow relative w-full">
          <VerticalTextImage
            imageSrc={Picture}
            verticalText="Hotel"
            imageTall={true}
            bottomText={
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    "Apartment Hotel<span class='block sm:inline'> For Neighborhood Stay</span>",
                }}
              />
            }
          />
          <div className="md:px-15 px-4">
            <div className="mb-[6.25rem]">
              <AboutContent />
            </div>
            <div className="mb-[6.25rem]">
              <Location />
            </div>
            <div className="mb-[6.25rem]">
              <MagazineParts />
            </div>
            <div className="mb-[6.25rem]">
              <MonthlyPlan />
            </div>
            <div className="mb-[6.25rem]">
              <News />
            </div>
            <FooterItems />
          </div>
        </div>
      </MenuBar>
    </>
  );
};

export default HotelPage;
